export const parseKnowledgeBaseSearchParams = (searchParams) => {
    const page = Number.parseInt(searchParams.get('page'));
    const search = searchParams.get('search');

    return search ? { page, search } : { page };
};
